<template>
    <div class="errorBookD">
        <p class="title" v-if="erroQuestions.length != 0">共有{{ total }}个错题</p>
        <van-collapse v-model="activeNames" accordion>
            <div v-infinite-scroll="load">
                <van-collapse-item
                    v-for="(item, index) in erroQuestions"
                    :key="item.id"
                    :title="item.title"
                    :name="index"
                >
                    <div
                        v-for="(obj, i) in item.answers"
                        :key="i"
                        class="answer"
                    >
                        <span
                            class="iconfont"
                            :class="
                                obj.isTrue
                                    ? 'icon-dui color39b'
                                    : 'icon-cuo colord61'
                            "
                        ></span
                        >{{ obj.answer }}
                    </div>
                    <div class="like-icon">
                        <span class="colord61 font12" @click="removeq(item.id)"
                            >删除</span
                        >
                    </div>
                </van-collapse-item>
            </div>
        </van-collapse>
        <van-empty v-if="erroQuestions.length == 0 && !loading" description="暂无数据" />
        <p class="prompt" v-if="loading">加载中...</p>
        <p class="prompt" v-if="noMore">没有更多了</p>
    </div>
</template>

<script>
import { Dialog } from "vant";
export default {
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },
    data() {
        return {
            activeNames: ["1"],
            examId: -1,
            total: -1,
            erroQuestions: [],
            currentPage: 0,
            loading: false,
            noMore: false,
        };
    },
    created() {
        this.examId = this.$route.query.id;
    },
    methods: {
        load() {
            if (this.total == this.erroQuestions.length) return false;
            this.currentPage++;
            this.initError();
        },
        initError() {
            this.loading = true
            this.$post("/index/Examquestiondetailerrorlog/getList", {
                exam_question_id: this.examId,
                row: 10,
                page: this.currentPage,
            }).then((res) => {
                this.loading = false
                if (res.code == 200) {
                    this.total = res.data.sum;
                    res.data.list.map((item) => {
                        if (item.answer_plan == null) return false;
                        let mistakes = {
                            id: item.id,
                            title: item.title,
                            answers: [],
                        };
                        const en = ["A", "B", "C", "D", "E", "F", "G", "H"];
                        item.answer_plan.split("\n").map((iterator, index) => {
                            mistakes.answers.push({
                                isTrue: false,
                                answer: en[index] + " " + iterator,
                            });
                        });
                        switch (item.type) {
                            case 1: {
                                mistakes.answers[
                                    en.indexOf(item.answer)
                                ].isTrue = true;
                                break;
                            }
                            case 2: {
                                item.answer.split(",").map((it) => {
                                    if (it != "") {
                                        mistakes.answers[
                                            en.indexOf(it)
                                        ].isTrue = true;
                                    }
                                });
                                break;
                            }
                            case 3: {
                                item.answer == "对"
                                    ? (mistakes.answers[0].isTrue = true)
                                    : (mistakes.answers[1].isTrue = true);
                                break;
                            }
                        }
                        this.erroQuestions.push(mistakes);
                    });
                    if (this.total == this.erroQuestions.length) {
                      this.noMore = true
                    }
                } else {
                    this.total = 0;
                }
            });
        },
        removeq(id) {
            Dialog.confirm({
                message: "确定删除吗",
            })
                .then(() => {
                    this.$post("/index/Examquestiondetailerrorlog/del", {
                        id: id,
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$toast.success('删除错题成功');
                            this.noMore = false
                            this.currentPage = 1;
                            this.erroQuestions = [];
                            this.initError();
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.errorBookD {
    .title {
        line-height: 50px;
        font-weight: 600;
        text-indent: 10px;
    }
    .like-icon {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        & > span {
            padding: 2px 5px;
            border-radius: 4px;
            border: 1px solid #fc7500;
        }
    }
    .answer {
        margin-bottom: 5px;
        padding: 10px 8px;
        background: #f4f4f4;
        border-radius: 10px;
        .iconfont {
            margin-right: 4px;
        }
    }
    .prompt {
        text-align: center;
        font-size: 14px;
        color: #5e6d82;
        line-height: 60px;
    }
}
</style>